<script setup lang="ts">
    import { useSuccessDialog } from '@/js/stores/success-dialog';
    import Modal, { ModalSize } from '../Modal.vue';
    import SuccessCheck from '../SuccessCheck.vue';

    const successDialogStore = useSuccessDialog();
</script>
<template>
    <Modal
        :size="ModalSize.Small"
        :show="successDialogStore.open"
        :padding="false"
        @close="successDialogStore.close"
    >
        <div class="m-auto w-80 py-10">
            <SuccessCheck :message="successDialogStore.dialogConfig.message" />
        </div>
    </Modal>
</template>
